import React, { useEffect } from 'react';
import { useRecoilState, } from 'recoil';
import { dashboardOptionAtom } from '../../../atoms/Atoms';
import Header from './shared-components/Header';
import SalesAnalytics from './shared-components/SalesAnalytics';
import Trends from './shared-components/trends/Trends';
import UserAnalytics from './shared-components/UserAnalytics';
import PrepInventory from './shared-components/PrepInventory';
import TopProducts from './shared-components/TopProducts';
import DashboardStatistics from './shared-components/DashboardStatistics';

function Dashboard() {
  const [dashboardOption, setDashboardOption] = useRecoilState(dashboardOptionAtom);

  useEffect(() => {
    setDashboardOption(0);
  }, []);

  return (
    <div>
      <Header />
      {dashboardOption === 0 ?
        <SalesAnalytics />
        : null}
      {dashboardOption === 4 ?
        <Trends />
        : null}
      {dashboardOption === 6 ?
        <UserAnalytics />
        : null}
      {dashboardOption === 7 ?
        <PrepInventory />
        : null}
      {dashboardOption === 8 ?
        <TopProducts />
        : null}
      {dashboardOption === 9 ?
        <DashboardStatistics />
        : null}
    </div>
  );
}

export default Dashboard;
